import { render } from "./columnExpertInfo.vue?vue&type=template&id=024fc852&scoped=true&ts=true"
import script from "./columnExpertInfo.vue?vue&type=script&lang=ts"
export * from "./columnExpertInfo.vue?vue&type=script&lang=ts"

import "./columnExpertInfo.vue?vue&type=style&index=0&id=024fc852&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024fc852"]])

export default __exports__